import { COOKIE_CURRENCY_OVERRIDE } from "@faire/web--source/common/consts/COOKIE_CURRENCY_OVERRIDE";
import { removeCookie, setCookies } from "@faire/web--source/common/cookies";
import { CurrencyStore } from "@faire/web--source/common/currency/CurrencyStore";
import { getLocation } from "@faire/web--source/common/globals/getLocation";
/**
 * @deprecated Use CurrencyStore.get().effectiveCurrency
 */ var getEffectiveCurrency = function() {
    return CurrencyStore.get().effectiveCurrency;
};
/**
 * @deprecated use CurrencyStore.get().setCurrency
 */ var updateCurrencyConfiguration = function(currency) {
    CurrencyStore.get().setCurrency(currency);
};
/**
 * Sets the retailer's explicitly selected currency and reloads the page.
 * @param currency the user's explicit currency selection
 */ export var selectCurrency = function(currency) {
    var _getLocation;
    currency ? setCookies(COOKIE_CURRENCY_OVERRIDE, currency) : removeCookie(COOKIE_CURRENCY_OVERRIDE);
    updateCurrencyConfiguration(currency);
    CurrencyStore.get().configuration.selectedCurrency = getEffectiveCurrency();
    (_getLocation = getLocation()) === null || _getLocation === void 0 ? void 0 : _getLocation.reload();
};
